import { Drawer as DrawerMUI, IconButton, styled } from "@mui/material";

export const DrawerStyled = styled(DrawerMUI)(() => ({
  "& .MuiDrawer-paper": {
    background: "transparent",
    boxShadow: "none",
    display: "flex",
    flexDirection: "row",
  },
}));

export const HeaderDrawer = styled("header")(() => ({
  background: "#EDF5FB",
  borderRadius: "8px 8px 0 0",
  height: 80,
  padding: "28px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const ButtonClose = styled(IconButton)(() => ({
  backgroundColor: "#FFFFFF !important",
  padding: "2px !important",
  borderRadius: "20px",
}));

export const MainSection = styled("section")(() => ({
  height: "calc(100% - 30px)",
  width: "70vw",
  marginTop: 15,
  background: "white",
  borderRadius: 8,
  marginRight: 15,
  "@media (max-width: 1024px)": {
    width: "65vw",
  },
  "@media (max-width: 768px)": {
    width: "60vw",
  },
}));

export const Content = styled("section")(() => ({
  maxHeight: "calc(100% - 80px)",
  overflowY: "auto",
}));
